import React, { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { selectUser, selectUserLoading } from "../../store/userSlice";
import { Navigate } from "react-router-dom";
import { useAuthModal } from "../../contexts/AuthModalContext";

function AdminRoute({ children }) {
  const user = useAppSelector(selectUser);
  const loading = useAppSelector(selectUserLoading);
  const { openSignIn } = useAuthModal();

  useEffect(() => {
    if (!loading && !user) {
      openSignIn();
    }
  }, [loading, user, openSignIn]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) return <Navigate to="/" replace />;
  if (user.role?.name !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

export default AdminRoute;
